import RamadanContentList, {
  RamadanContentListParameters,
} from "@components/layouts/content/RamadanContentList";
import { createComponentElement } from "../creators/createComponentElement";
import { useComponentData } from "../hooks/useComponentData";
import { ContentComponent } from "../types";

const Component = createComponentElement((props, ref) => {
  const { getParameterValues, content, isLoading, ...other } =
    useComponentData<RamadanContentListParameters>(props, ref);

  const { quranUrl, programsUrl, prayersUrl, podcastsUrl, booksUrl } =
    getParameterValues([
      "quranUrl",
      "programsUrl",
      "prayersUrl",
      "podcastsUrl",
      "booksUrl",
    ]);

  return (
    <RamadanContentList
      content={content}
      parameterValues={{
        booksUrl,
        programsUrl,
        quranUrl,
        prayersUrl,
        podcastsUrl,
      }}
      isLoading={isLoading}
    />
  );
});

export const RamadanContentListComponent: ContentComponent = {
  identifier: "COM:RAMADAN:CONTENT:LIST",
  component: Component,
};
